import React from 'react';
import { Link, HashRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux';
import Result from './Result';
import { setIdCardImage, setIdCardImageBack, setSelectedIdType, setSelfieVideo, setIdCardResponse, setSelfieResponse, setIdCardBackResponse, setCheckinCurrentPageName } from '../../action/autoCheckin';
import { popupOpenClose, setCardChecksData } from '../../../action/action';
import { setGoHome } from '../../action/homeAction';
import { mobileCheckinColorConfig } from '../../JS/colorConfig'
import {CMSPath, DEBUG, DEMO} from '../../../config/constant';
import { sendConfidenceScore } from '../../action/autoCheckin';
import moment from 'moment';
import {withTranslation} from 'react-i18next';
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import { sendAnalytics } from '../../../action/homeAction';

function fetchWithTimeout(uri, options = {}, time = 5000){
  
  const controller = new AbortController()
  const config = { ...options, signal: controller.signal }
  const timeout = setTimeout(() => {
    controller.abort()
  }, time)
  return fetch(uri, config)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`${response.status}: ${response.statusText}`)
      }
      return response
    })
    .catch((error) => {
      if (error.name === 'AbortError') {
        throw new Error('TIMEOUT')
      }
      throw new Error(error.message)
    })
}

class ConfidenceShow extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      idCardResp: null,
      faceMatchResp:null,
      idCardError: false,
      faceMatchError: false,
      loadingPerc: 50,
      sessionToken: localStorage.getItem('GuestJourneySessionToken'),
      faceAPICalled: false,
      idCardAPICalled:false,
      error_message: null,
      ga_error_message: null,
      livenessSuccess: true,
      confValid: null,
      upload_called: false,
      trigger_api: false,
      image_keys: [],
      uploaded_image_counter: 0,
      expiry_date_err:false,
      maxLimit: 80,
      mrzApiCalled: false,
      maintainUpdatedCardData: 0,
      autoProgressPoints: 0
    }

    this.timeIntervalRefrence = null
    this.parseSelfie = this.parseSelfie.bind(this);
    this.readFile = this.readFile.bind(this);
    this.resOnError = this.resOnError.bind(this);
    this.clearFormData = this.clearFormData.bind(this);
    this.validateConfidence = this.validateConfidence.bind(this);
    this.getObject = this.getObject.bind(this);
    this.idCardDataUrl = null;
    this.idCardBackDataUrl = null;
    this.selfieDataUrl = null;
    this.updatedCardCheckData = this.props.cardChecksData;
    this.ml_headers = {
                          "x-api-key" : "VUsa50QUiY6PNSgZ1vPCE1iDhX5PVETMu4SFwb4c",
                          "x-app-name" : "guest-journey",
                          "Content-Type": "application/json"
                        };
  }

  getObject(key) {
    let obj = {}

    if (key == 'idType'){
      return this.state.idCardResp.type;
    }

    for (obj of this.state.idCardResp.fields){
      if (obj.key == key){
        return obj;
      }
    }
  }

  readFile(uri, form_key, side){

    const self = this;
    function readBinaryFile(fileEntry) {
      fileEntry.file(function (file) {
          var reader = new FileReader();

          reader.onloadend = function() {
           
              let res = this.result.split(",")[1];
              // console.log("file reader image",res);
              if(form_key == "idcard_image"){
                if(!(self.props.selectedIdType && self.props.selectedIdType.bothSideImageRequired)){
                  self.idCardDataUrl = res;
                } else {
                  if(side == "front"){
                    self.idCardDataUrl = res;
                  } else {
                    self.idCardBackDataUrl = res;
                  }
                }
              }else if(form_key == "selfie_image"){
                self.selfieDataUrl = res;
              }
          };

          reader.readAsDataURL(file);

      }, self.resOnError);
    }

    // console.log('reading file: ', form_key);
    if(window.device) window.resolveLocalFileSystemURL(uri, readBinaryFile, self.resOnError);
  }

  resOnError(error) {
    console.log('error: ', error);
      // alert("resOnError - " + error.code);
    }


  clearFormData() {
      console.log('setting idcard image and selfie video null');
      this.props.setSelfieVideo(null);
      this.props.setIdCardImage(null);
      this.props.setIdCardImageBack(null);

      const platform = window.device ? window.device.platform: "web";
      
      if (navigator.camera && platform === "iOS") {

        const onCleanupSuccess = ()=> {
          console.log("Camera cleanup success.")
        }

        const onCleanupFail = (message)=> {
            console.log('Failed because: ' + message);
        }

        navigator.camera.cleanup(onCleanupSuccess, onCleanupFail);
      }
  }

  parseMultiShotSelfie(){
    if(!this.state.faceAPICalled){
      this.setState({faceAPICalled:true});

      let url = this.idCardDataUrl

      if(process.env.REACT_APP_WEB_VERSION_ENABLED == "true"){
        console.log("multishot this.idCardDataUrl", this.idCardDataUrl);
        url = this.idCardDataUrl.imageUrl.replace("data:image/jpeg;base64,","")
      }
      setTimeout(() => {

        fetch("https://ilm64dzzu4.execute-api.us-east-1.amazonaws.com/Production/guest-journey/verify-face-with-multishot/", {
          method: 'POST',
          body: JSON.stringify({
            "idcard_image": url, //this.idCardDataUrl,
            "selfie_key": this.state.image_keys
          }),
          headers: {
            "x-api-key" : "VUsa50QUiY6PNSgZ1vPCE1iDhX5PVETMu4SFwb4c",
            "x-app-name" : "guest-journey",
            "Content-Type": "application/json"
          },})
        .then((response) => {
         
          if (!response.ok){
            this.clearFormData();
            response.json().then((data) => {
              this.setState({error_message: data.detail, ga_error_message: data.detail, faceMatchError: true});
              this.props.setSelfieResponse(null);
              this.clearFormData();
            });
          } else {
            response.json().then((data) => {
              this.setState({faceMatchResp: data});
              this.props.setSelfieResponse(data);
              if(data.selfie_frame_url){
                console.log('Received selfie frame.');
                this.props.setSelfieVideo({videoUrl: data.selfie_frame_url});
              }

              // this.setState(prev => ({maxLimit: prev.maxLimit + 13}));
              // this.progressBar(this.state.maxLimit + 13);
                // this.setState({ loadingPerc: 94 });
                // if(this.timeIntervalRefrence) {
                //   clearInterval(this.timeIntervalRefrence);
                // }
            });
          }
          this.setState({loadingPerc: this.state.loadingPerc + 25})
        })
        .catch(error => {
          console.log(`error face api: ${error} - ${error.name} - ${error.message}`);
          if(DEBUG){
            alert(`error face api: ${error} - ${error.name} - ${error.message}`);
          }
          if (error.name === 'TIMEOUT'){
            this.setState({error_message: 'It is taking longer than usual to process your request. PLease try again later.',
                          ga_error_message: 'It is taking longer than usual to process your request. PLease try again later.'})
          }
          this.setState({faceMatchError:true})
          this.clearFormData();
          console.log('face resp error: ', error, error.response, error.name);
          if (error.response && error.response.data && error.response.data.detail){
            this.setState({error_message: error.response.data.detail, ga_error_message: error.response.data.detail})
          };
          this.props.setSelfieResponse(null);
        });  


      }, 1000)

      

    }
    
  }


  parseVideoSelfie(){
    if(!this.state.faceAPICalled){
      this.setState({faceAPICalled:true});
      fetch("https://ilm64dzzu4.execute-api.us-east-1.amazonaws.com/Production/guest-journey/verify-face-with-video", {
        method: 'POST',
        body: JSON.stringify({
          "idcard_image": this.idCardDataUrl,
          "selfie_key": this.selfieDataUrl
        }),
        headers: {
          "x-api-key" : "VUsa50QUiY6PNSgZ1vPCE1iDhX5PVETMu4SFwb4c",
          "x-app-name" : "guest-journey",
          "Content-Type": "application/json"
        },})
      .then((response) => {
       
        if (!response.ok){
          this.clearFormData();
          response.json().then((data) => {
            this.setState({error_message: data.detail, ga_error_message: data.detail, faceMatchError: true});
            this.props.setSelfieResponse(null);
            this.clearFormData();
          });
        } else {
          response.json().then((data) => {
            this.setState({faceMatchResp: data});
            this.props.setSelfieResponse(data);
            if(data.selfie_frame_url){
              console.log('Received selfie frame.');
              this.props.setSelfieVideo({videoUrl: data.selfie_frame_url});
            }
            this.setState(prev => ({loadingPerc: prev.loadingPerc + 7}));
          });
        }
      })
      .catch(error => {
        console.log(`error face api: ${error} - ${error.name} - ${error.message}`);
        if(DEBUG){
          alert(`error face api: ${error} - ${error.name} - ${error.message}`);
        }
        
        if (error.name === 'TIMEOUT'){
          this.setState({error_message: 'It is taking longer than usual to process your request. PLease try again later.',
                        ga_error_message: 'It is taking longer than usual to process your request. PLease try again later.'})
        }
        this.setState({faceMatchError:true})
        this.clearFormData();
        console.log('face resp error: ', error, error.response, error.name);
        if (error.response && error.response.data && error.response.data.detail){
          this.setState({error_message: error.response.data.detail, ga_error_message: error.response.data.detail})
        };
        this.props.setSelfieResponse(null);
      });

    }
    
  }

  parseSelfie(){
    if(!this.state.faceAPICalled){
      this.setState({faceAPICalled:true});
      fetch("https://ilm64dzzu4.execute-api.us-east-1.amazonaws.com/Production/verify-face/", {
        method: 'POST',
        body: JSON.stringify({
          "idcard_image": this.idCardDataUrl,
          "selfie_image": this.selfieDataUrl
        }),
        headers: {
          "x-api-key" : "VUsa50QUiY6PNSgZ1vPCE1iDhX5PVETMu4SFwb4c",
          "x-app-name" : "guest-journey",
          "Content-Type": "application/json"
        },})
      .then((response) => {
       
        if (!response.ok){
          this.clearFormData();
          response.json().then((data) => {
            this.setState({error_message: data.detail, ga_error_message: data.detail, faceMatchError: true});
            this.props.setSelfieResponse(null);
            this.clearFormData();
          });
        } else {
          response.json().then((data) => {
            this.setState({faceMatchResp: data});
            this.props.setSelfieResponse(data);
            this.setState(prev => ({loadingPerc: prev.loadingPerc + 7}));
          });
        }
      })
      .catch(error => {
        console.log(`error face api: ${error} - ${error.name} - ${error.message}`);
        if(DEBUG){
          alert(`error face api: ${error} - ${error.name} - ${error.message}`);
        }
        
        if (error.name === 'TIMEOUT'){
          this.setState({error_message: 'It is taking longer than usual to process your request. PLease try again later.',
                        ga_error_message: 'It is taking longer than usual to process your request. PLease try again later.'})
        }
        this.setState({faceMatchError:true})
        this.clearFormData();
        console.log('face resp error: ', error, error.response, error.name);
        if (error.response && error.response.data && error.response.data.detail){
          this.setState({error_message: error.response.data.detail, ga_error_message: error.response.data.detail})
        };
        this.props.setSelfieResponse(null);
      });

    }
    
  }

  uploadFile(uri){

    let arr = uri.split("/");
    let ml_headers = this.ml_headers;
    const self = this;
    const key = `checkin/${this.state.sessionToken}/${`${Math.random() * 1000}`.split(".")[0]}.jpeg`

    const readFile = async(uri, presigned_data, success) => {

      if(process.env.REACT_APP_WEB_VERSION_ENABLED == "true"){
        // var blob = new Blob([new Uint8Array(uri)], { type: file.type });

        const blob = await fetch(uri).then((r) => r.blob({ type: 'jpeg' }));
                    
        success(blob, presigned_data).then((data) => {console.log(data);}
                ).catch((error) => {
                                console.log(`Error while uploading file: ${error}`);
                                this.setState({error_message: 'Something went wrong.', ga_error_message: error, idCardError: true});
                                this.props.setIdCardResponse(null);
                                this.clearFormData();
                              });
            return
      }

          const readBinaryFile = (fileEntry) => {
            fileEntry.file(function (file) {
                var reader = new FileReader();
                reader.onloadend = function() {
                    var blob = new Blob([new Uint8Array(this.result)], { type: file.type });
                    
                    success(blob, presigned_data).then((data) => {console.log(data);}
                            ).catch((error) => {
                                            console.log(`Error while uploading file: ${error}`);
                                            this.setState({error_message: 'Something went wrong.', ga_error_message: error, idCardError: true});
                                            this.props.setIdCardResponse(null);
                                            this.clearFormData();
                                          });
                };
                reader.readAsArrayBuffer(file);
            }, self.resOnError);
          }
          if(window.device) window.resolveLocalFileSystemURL(uri, readBinaryFile, self.resOnError);
    }

    const fetchPreSignedURL = (arr, uri) => {
      let format

      if(process.env.REACT_APP_WEB_VERSION_ENABLED == "true") format = uri.slice(uri.indexOf("/")+1, uri.indexOf(";"))
      console.log("fetchPreSignedURL", format);
      return new Promise ((resolve, reject) => {
         fetch("https://ilm64dzzu4.execute-api.us-east-1.amazonaws.com/Production/guest-journey/get-upload-url", {
        method: 'POST',
        body: JSON.stringify({
          'file_name': key,
          'ContentType': `image/${ format || arr[arr.length -1].split(".")[1]}`
        }),
        headers: ml_headers
      }).then((response) => {
        if (!response.ok){
          response.json().then((data) => {
            console.log(`error while getting presignedURL: ${data}`);
              reject('error while getting presignedURL')
         });
        } else {
          response.json().then((data) => {
            resolve(data);
          });
        }
      })})
    }

    const doUpload = (file, presigned_data) => {
      console.log(`upload called: ${file} - ${presigned_data}`);
      return new Promise((resolve, reject) => {fetch(presigned_data.url, {
        method: 'PUT',
        body: file,
        headers: {
          "Content-Type": process.env.REACT_APP_WEB_VERSION_ENABLED == "true" ? `image/jpeg` : `image/${arr[arr.length-1].split(".")[1]}`
        }
      }).then((response) => {
        
        if (!response.ok){
            console.log(`uploaded failed`);
            self.setState(prev => ({uploaded_image_counter: prev.uploaded_image_counter + 1}));
            self.setState({error_message: "Something went wrong.", ga_error_message: "Error while uploading data.", idCardError: true});
            self.props.setIdCardResponse(null);
            self.clearFormData();
            reject(`Error while uploading`);

        } else {
          self.setState(prev => ({uploaded_image_counter: prev.uploaded_image_counter + 1}));      
            self.selfieDataUrl = key;
            self.setState({trigger_api: !self.state.trigger_api});
            let keys = [...self.state.image_keys]
            keys.push(key)
            self.setState({image_keys: keys});
            console.log(`uploaded successfully:`);
            resolve('uploaded successfully');
          }
        }).catch(error => {
          self.setState(prev => ({uploaded_image_counter: prev.uploaded_image_counter + 1}));
          console.log("error while uploading", error, error.message)
          self.setState({error_message: "Something went wrong.", ga_error_message: error, idCardError: true});
          self.props.setIdCardResponse(null);
          self.clearFormData();
          reject(`Error while uploading`);

        })
    
      })

    }

    fetchPreSignedURL(arr, uri).then((data) => {readFile(uri, data, doUpload)}
                          ).catch((error) => {
                                          console.log(`Error while uploading file: ${error}`);
                                          this.setState({error_message: 'Something went wrong.', ga_error_message: error, idCardError: true});
                                          this.props.setIdCardResponse(null);
                                          this.clearFormData();
                                        }) 
  }

  extractTextsFromId(imageContent, side, idType){

    // console.log("imageContent",imageContent)
    if(side == "front"){
      this.parseIdCard(this.idCardDataUrl, "", "front", idType);
    } else {
      this.parseIdCard(this.idCardBackDataUrl, "", "back", idType);
    }
    return

    fetch("https://vision.googleapis.com/v1/images:annotate/?key=AIzaSyAFwpDICdlbldOY4tQQRJQkAetrbYMz2NA", {
        method: 'POST',
        body: JSON.stringify({"requests": [{
                    "image": {
                        "content": process.env.REACT_APP_WEB_VERSION_ENABLED == "true" 
                        ? imageContent.imageUrl.replace("data:image/jpeg;base64,","")
                        : imageContent
                    },
                    "features": [
                        {"type": "TEXT_DETECTION"}
                    ],
                    "imageContext": {
                        "languageHints": ["en"]
                            }
                }]}),
        headers: {
          "Content-Type": "application/json"
        },
      }).then((response) => {
          if (!response.ok){
            response.json().then((data) => {
              console.log("ocr response: ", data);
              if(side == "front"){
                this.parseIdCard(this.idCardDataUrl, "", "front", idType);
              } else {
                this.parseIdCard(this.idCardBackDataUrl, "", "back", idType);
              }
            });
          } else {
            response.json().then((data) => {

              let ocrTexts = (Object.keys(data).length > 0 && data.responses[0] && data.responses[0].fullTextAnnotation && data.responses[0].fullTextAnnotation.text) 
                              ? data.responses[0].fullTextAnnotation.text 
                              : ''

              if(side == "front"){
                console.log("classfy api for front")
                // this.setState({ idCardOcrTexts :data.responses[0].fullTextAnnotation.text})
                this.parseIdCard(this.idCardDataUrl, ocrTexts, "front", idType);
              } else {
                console.log("classfy api for back")
                // this.setState({ idCardBackOcrTexts :data.responses[0].fullTextAnnotation.text})
                this.parseIdCard(this.idCardBackDataUrl, ocrTexts, "back", idType);
              }
            });
        }
      }).catch(error => {
        console.log("ocr response: ", error);
              if(side == "front"){
                this.parseIdCard(this.idCardDataUrl, "", "front", idType);
              } else {
                this.parseIdCard(this.idCardBackDataUrl, "", "back", idType);
              }
      })
  }

  mergeResponses(idCardBackResponse){
    let mergedOjects
    let firstResponse = this.props.idCardResponse
    let secondResponse = idCardBackResponse

    for(let key in firstResponse){
      if(key == "type"){
        firstResponse[key] = secondResponse[key]
      } else if(key == "raw_text"){
          firstResponse[key] = firstResponse[key].concat(secondResponse[key])
      } else if(key == "fields"){
          mergedOjects = firstResponse[key];

          for(let i =0; i< secondResponse[key].length; i++){
          let secondResponseFiledObj = secondResponse[key][i];
            
            for(let j =0; j< firstResponse[key].length; j++){
                let firstResponseFieldObj = firstResponse[key][j];

                if(secondResponseFiledObj.key == firstResponseFieldObj.key){
                    mergedOjects.splice(j,1, secondResponseFiledObj);
                    break;
                } else if(j === firstResponse[key].length - 1){
                    mergedOjects.push(secondResponseFiledObj);
                    break;
                }
            }
          }
          firstResponse[key] = mergedOjects
      }
    }
    console.log("firstResponse",firstResponse);
    this.props.setIdCardResponse(firstResponse);
  }

  parseIdCard(cardUrl, ocr_text, side, idType){
    // if(!this.state.idCardAPICalled){

        let url = cardUrl

        if(process.env.REACT_APP_WEB_VERSION_ENABLED == "true"){
          url = cardUrl.imageUrl.replace("data:image/jpeg;base64,","")
        }

        this.setState({idCardAPICalled: true});
        fetch(`${process.env.REACT_APP_INNSPIREONE_HOST}/ai-services/classify-id-card/`, {
        method: 'POST',
        body: JSON.stringify({
          "idcard_image": url,
          "ocr_text": ocr_text,
          "page": side,
          "type": idType
        }),
        headers: {
          // "x-api-key" : "VUsa50QUiY6PNSgZ1vPCE1iDhX5PVETMu4SFwb4c",
          // "x-app-name" : "guest-journey",
          "Content-Type": "application/json",
          "Authorization": `Api-Key ${this.props.freshChatData.logout.webIntegrationId}`
        },
        
      })
      .then((response) => {
        if (!response.ok){
          response.json().then((data) => {
            this.setState({error_message: data.detail, ga_error_message: data.detail, idCardError: true});
            this.props.setIdCardResponse(null);
            this.clearFormData();
          });
          } else {
            response.json().then((data) => {
              // alert("Id Card Response data : " + JSON.stringify(data))
              if(!( this.props.selectedIdType && this.props.selectedIdType.bothSideImageRequired)){
                console.log("parseIdCard API response: when both side not required",data)
                this.setState({idCardResp:data});
                this.props.setIdCardResponse(data);
                // this.setState(prev => ({maxLimit: prev.maxLimit + 7}));
                // this.progressBar(this.state.maxLimit + 7) 
              } else {
                if(side == "front"){
                  console.log("parseIdCard API response: when both side are required: front")
                  this.setState({idCardResp:data});
                  this.props.setIdCardResponse(data);
                  // this.setState(prev => ({maxLimit: prev.maxLimit + 3}));
                  // this.progressBar(this.state.maxLimit + 3)
                } else {
                  console.log("parseIdCard API response: when both side are required: back")
                  this.setState({idCardBackResp:data});
                  // this.props.setIdCardBackResponse(data);

                  this.mergeResponses(data);

                  // this.setState(prev => ({maxLimit: prev.maxLimit + 4}));
                  // this.progressBar(this.state.maxLimit + 4)
                }
              }
            });
        }
        this.setState({loadingPerc: this.state.loadingPerc + 25})
      })
      .catch(error => {
        this.clearFormData();
        console.log("parseIdCard API response failed:", error)
        if(DEBUG){
          alert(`error idcard api: ${error} - ${error.name} - ${error.message}`);
        }
        this.setState({idCardError:true});
        this.props.setIdCardResponse(null);
        this.props.setIdCardBackResponse(null);
        if (error.response && error.response.data && error.response.data.detail){
          this.setState({error_message: error.response.data.detail, ga_error_message: error.response.data.detail})
        }
        if(window.FireBasePlugin){
          window.FirebasePlugin.logError("idcard api failed in checkin :" + error.response.data.detail)
        }
        this.clearFormData();
      });
    // }
  }

  progressBar(maxLimit){
    let i = 0;


    if(this.timeIntervalRefrence != null){
      clearInterval(this.timeIntervalRefrence)
    }

    this.timeIntervalRefrence = setInterval(() => {
      if (this.state.autoProgressPoints >= 50) {
        clearInterval(this.timeIntervalRefrence);
      } else {
        // i++;
        this.setState(prev => ({loadingPerc:prev.loadingPerc + 1}))
        this.setState({autoProgressPoints: this.state.autoProgressPoints + 1})
      }
    }, 850);
  }

  dateFormatHandler = (date) => {

    if(!date){
      return null;
    }

    let now = moment(date);
   
    if(!now.date()){
      now = moment(date,"DD-MM-YYYY");
    }

    return now ? now.format("YYYY-MM-DD") : null;
  }

  validateExpiryDate = () => {
    const id_obj = this.getObject('Date of Expiry');
    const expiry_date = id_obj ? this.dateFormatHandler(id_obj.value) : null;
    const today = moment();

    if(!expiry_date){
      return;
    }

    const diff = today.diff(expiry_date,"days");
    if(diff > 0){
      this.setState({expiry_date_err:true,error_message:"ID card is expired. Please scan valid ID card.", ga_error_message: "ID card is expired. Please scan valid ID card."})
    }

    
  }


  componentDidMount(){
    if(this.props.selectedIdType && this.props.selectedIdType.bothSideImageRequired){
      
      if(process.env.REACT_APP_WEB_VERSION_ENABLED == "true" ){
        this.idCardDataUrl = this.props.idCardImage
        this.idCardBackDataUrl = this.props.idCardImageBack
      } else {
        this.readFile(this.props.idCardImage.imageUrl, 'idcard_image', "front")
        this.readFile(this.props.idCardImageBack.imageUrl, 'idcard_image', "back")
      }
    } else {
      if(process.env.REACT_APP_WEB_VERSION_ENABLED == "true" ){
        this.idCardDataUrl = this.props.idCardImage
      } else {
        this.readFile(this.props.idCardImage.imageUrl, 'idcard_image', "front")
      }
    }
    // this.readFile(this.props.selfieVideo.videoUrl, 'selfie_image')

    // console.log(`video url: ${this.props.selfieVideo.videoUrl}`);
    let i=0;

    if(!this.props.cardChecksData.disableLivelinessCheck){
      for (i=0; i<this.props.selfieVideo.images.length; i++){
        if(!this.state.upload_called){this.uploadFile(this.props.selfieVideo.images[i])}
      }
      this.setState({upload_called: true});
    } else {
        // this.setState(prev => ({maxLimit: prev.maxLimit + 13}));
        // this.progressBar(this.state.maxLimit + 13);
        // this.setState(prev => ({loadingPerc: prev.loadingPerc + 17}));

        try {
          if(this.props.selectedIdType && this.props.selectedIdType.bothSideImageRequired){
            this.setState({mrzApiCalled: true});
            this.extractTextsFromId(this.idCardDataUrl, "front", this.props.selectedIdType.key);
            this.extractTextsFromId(this.idCardBackDataUrl, "back", this.props.selectedIdType.key);
          } else {
            this.setState({mrzApiCalled: true});
            this.extractTextsFromId(this.idCardDataUrl, "front", this.props.selectedIdType.key);          
          }
        } catch (error) {
          console.log(`${error.name} - ${error.message} - ${error}`);
          if(DEBUG){
            alert(`${error.name} - ${error.message} - ${error}`)
          }
        }
    }
    this.setState({loadingPerc: this.state.loadingPerc + 10})

    window.scrollTo(0,0);
    this.progressBar(80); 
    mobileCheckinColorConfig(this.props.menuColor);

    this.props.setCheckinCurrentPageName("VERIFYING YOUR IDENTITY")

    const checkin_verifying_identity_event_sent = localStorage.getItem("checkin_verifying_identity_event_sent")

    if(!checkin_verifying_identity_event_sent){
      // Send Analytics
      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
      this.props.sendAnalytics(
          null, // as no guesdetails in logout state 
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          "VERIFYING YOUR IDENTITY",
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "pageName": "VERIFYING YOUR IDENTITY", "widgetSessionId": localStorage.getItem("checkinSessionToken")}, 
          0, 
          false, // guest is not logged in
          () => localStorage.setItem("checkin_verifying_identity_event_sent",true)
      );
      //
    }
 
  }

  componentDidUpdate(prevProps,prevState){
    
    if (this.state.idCardResp && this.state.confValid == null) {
      if (this.props.cardChecksData.disableLivelinessCheck) {
        this.validateOnlyIdConfidence();
      } else if(this.state.faceMatchResp) {
        // this.validateExpiryDate();
        this.validateConfidence();
      }
    }

    if(this.props.selfieVideo && !this.state.mrzApiCalled 
        && (this.state.uploaded_image_counter == this.props.selfieVideo.images.length) 
        && ((this.props.selectedIdType && this.props.selectedIdType.bothSideImageRequired)
            ? this.idCardDataUrl && this.idCardBackDataUrl: this.idCardDataUrl) ){
      try {
        // this.parseSelfie();
        // this.parseVideoSelfie();
        this.parseMultiShotSelfie();
        if(this.props.selectedIdType && this.props.selectedIdType.bothSideImageRequired){

          // this.parseIdCard(this.idCardDataUrl, this.state.idCardOcrTexts, "front");
          // this.parseIdCard(this.idCardBackDataUrl, this.state.idCardBackOcrTexts, "back");
          this.setState({mrzApiCalled: true});
          this.extractTextsFromId(this.idCardDataUrl, "front", this.props.selectedIdType.key);
          this.extractTextsFromId(this.idCardBackDataUrl, "back", this.props.selectedIdType.key);

        } else {
          
          this.setState({mrzApiCalled: true});

          this.extractTextsFromId(this.idCardDataUrl, "front", this.props.selectedIdType.key);          
        }
       
      } catch (error) {
        console.log(`${error.name} - ${error.message} - ${error}`);
        if(DEBUG){
          alert(`${error.name} - ${error.message} - ${error}`)
        }
        
      }
    }
    mobileCheckinColorConfig(this.props.menuColor);

    // if(this.ocrFormData.has('idcard_image')){
    //   this.parseIdCard();
    //   this.parseIdCard();
    //   this.ocrFormData.delete('idcard_image');
    //   this.props.setIdCardImage(null);
    // }

    // if(this.formData.has('idcard_image') && this.formData.has('selfie_video') && !this.state.faceAPICalled){
    //   this.parseSelfie();
    // }
  }


  validateOnlyIdConfidence = () => {
    let valid_id = false;

    const id_obj = this.getObject('idType')
    const conf = id_obj.confidence
    if (conf >= this.props.confidenceScores.guestIDValidation){
      valid_id = true;
    } else {
      this.setState({error_message: 'ID card confidence is low.', ga_error_message: 'ID card confidence is low.'});
      valid_id = false;
    }

    // this.setState(prev => ({loadingPerc: prev.loadingPerc!== 100 ? prev.loadingPerc + 6: prev.loadingPerc + 0}));
    this.setState({confValid: valid_id})

    let currentDateTime = moment();
    let countryCode = this.getObject("Country Code")

    console.log("this.getObject(Country Code)",this.getObject("Country Code"))
    let label = {...getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""}),
            "dateTime": currentDateTime,
            "guestIdentifier": countryCode ? countryCode.value : countryCode,
            "layoutTab": this.props.currentHomePage.tabName, "element": "widget", 
            "pageName": "VERIFYING YOUR IDENTITY", "widgetSessionId": localStorage.getItem("checkinSessionToken")
        }
    try{
      this.props.sendConfidenceScore(
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          "GUEST ID VALIDATION SCORE",
          {...label, "scoreValue": this.state.idCardResp.type.confidence,
          "valueSetFromCMSAsMinimumValue":this.props.confidenceScores.guestIDValidation}
      );
    } catch (error){
      alert("error in validating the confidence: " + error.message)
    }
  }

  validateConfidence = () => {

    let valid_id = false, valid_selfie = false;
    const id_obj = this.getObject('idType')
    const conf = id_obj.confidence
    if (conf >= this.props.confidenceScores.guestIDValidation){
      valid_id = true;
    } else {
      this.setState({error_message: 'ID card confidence is low.', ga_error_message: 'ID card confidence is low.'});
      valid_id = false;
    }
    
    const face_match_success = this.state.faceMatchResp.selfie.match >= this.props.confidenceScores.guestPhotoMatching; 
    const liveness_success = this.state.faceMatchResp.selfie.live >= this.props.confidenceScores.guestSelfieLiveliness;
    if (!face_match_success){
      this.setState({error_message: 'Face match confidence is low.', ga_error_message: 'Face match confidence is low.'});
    } else if(!liveness_success) {
      this.setState({error_message: 'Liveness detection failed.', ga_error_message: 'Liveness detection failed.', livenessSuccess: false });
    }
    
    valid_selfie = face_match_success && liveness_success;

    // this.setState(prev => ({loadingPerc: prev.loadingPerc!== 100 ? prev.loadingPerc + 6: prev.loadingPerc + 0}));
    this.setState({confValid: valid_id && valid_selfie})

    let currentDateTime = moment();
    let countryCode = this.getObject("Country Code")

    console.log("this.getObject(Country Code)",this.getObject("Country Code"))

    let label = {...getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""}),
            "dateTime": currentDateTime,
            "guestIdentifier": countryCode ? countryCode.value : countryCode,
            "layoutTab": this.props.currentHomePage.tabName, "element": "widget", 
            "pageName": "VERIFYING YOUR IDENTITY", "widgetSessionId": localStorage.getItem("checkinSessionToken")
        }
    try{
      this.props.sendConfidenceScore(
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          "GUEST ID VALIDATION SCORE",
          {...label, "scoreValue": this.state.idCardResp.type.confidence,
          "valueSetFromCMSAsMinimumValue":this.props.confidenceScores.guestIDValidation}
      );

      this.props.sendConfidenceScore(
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          "GUEST SELFIE LIVELINESS_SCORE",
          {...label, "scoreValue": this.state.faceMatchResp.selfie.live,
          "valueSetFromCMSAsMinimumValue":this.props.confidenceScores.guestSelfieLiveliness}
      );

      this.props.sendConfidenceScore(
          this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
          "GUEST PHOTO MATCHING SCORE",
          {...label, "scoreValue": this.state.faceMatchResp.selfie.match,
          "valueSetFromCMSAsMinimumValue":this.props.confidenceScores.guestPhotoMatching},
      );
    } catch (error){
      alert("error in validating the confidence: " + error.message)
    }
  }

  goBack = () => {
    this.props.setSelectedIdType(null);
    this.props.setIdCardImage(null);
    this.props.setIdCardImageBack(null);
    this.props.setSelfieVideo(null);
    this.props.goBack()
  }

  updatedCardData = () => {

    if(this.state.maintainUpdatedCardData < 1){

      if(this.props.cardChecksData.guestValidationMaxRetry){
        this.updatedCardCheckData.guestValidationMaxRetry = +this.props.cardChecksData.guestValidationMaxRetry - 1;
      }
      
    console.log(this.updatedCardCheckData)
    setCardChecksData(this.updatedCardCheckData)
    this.setState({maintainUpdatedCardData : this.state.maintainUpdatedCardData + 1})
    }
    return true;
  }

  goToNextScreen = this.props.setNextScreen();

  render() {
    const {t} = this.props
    return (
      this.state.faceMatchError 
      || this.state.idCardError 
      || this.state.confValid==false 
      || this.state.expiry_date_err ? ( process.env.REACT_APP_SHOW_SELFIE_AND_ID_SCAN_TOGETHER =="true" || (this.updatedCardData() && this.state.livenessSuccess)) ? <Result backBtn={() => {
                    this.props.setSelectedIdType(null);
                    this.props.setIdCardImage(null);
                    this.props.setIdCardImageBack(null);
                    this.props.setSelfieVideo(null);
                    this.props.goBack()
                  }}  ga_error_message={this.state.ga_error_message} page="confidance" success = {false} message={this.state.error_message} heading={"Identity Verification"} subheading={t('check_in.verify_your_identity')} /> 
                  : <Result backBtn={() => {
                    this.props.setSelfieVideo(null);
                    this.props.goBacktoSelfie()
                  }}  ga_error_message={this.state.ga_error_message} page="confidance" success = {false} message={this.state.error_message} heading={"Identity Verification"} subheading={t('check_in.verify_your_identity')}/> 
      :<div className="main-container">
        <header className="inner-pages w-footer subpages">
        <a onClick={() => this.goBack()} className="button-back">
          </a>
          <div className="heading align-center">
              <div class="splash-brand">
                  <img src={`${CMSPath}${this.props.logo}`} />
              </div>
            {/* <p className="bold" style = {{color:"inherit"}}>{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
          </div>
        </header>
        <section className="widgets padding-0 margin-0 container-bg confidenceshowsec">

          <div class="widget-header widget-header-checkin-inner confidenceshow">
              { this.props.currentWidgetObj.widgetHeaderImageUrl && 
                  <div class="widget-header-img">
                      <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                  </div>
              }

              {
                        process.env.REACT_APP_NEWER_DESIGN=="true" ?  
                          <>
                          <div class="widget-header-title">{"Identity Verification"}</div>
                          <div class="widget-header-subtitle">{t('check_in.verify_your_identity')}</div>
                          </>
                         :
                         <div class="widget-header-title">{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>

              }
              

          </div>

          <div className="widgets">
            <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
              <h2 className = "all-caps"></h2>
            </div>
            <div className="form-window">
              <div className="form-window-heading">
              {t('check_in.verify_your_identity')}
              </div>
              <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                <div className="form-row">
                  {/* <div className="progress-circle p33"> */}
                    <div id = 'progress-circle-percentage-cont' className={`progress-circle over50 p${this.state.loadingPerc}`}>
                      <span id = 'progress-circle-percentage'>{Math.min(this.state.loadingPerc, 100)}%</span>
                      <div className="left-half-clipper">
                        <div className="first50-bar"></div>
                        <div className="value-bar"></div>
                      </div>
                    </div>
                  {/* </div> */}
                </div>
                <div className="form-row margin-top-2 margin-bottom-2 disclaimer circle">
                  <p>{t('check_in.please_wait_verify_identity')}</p>
                </div>
                <div className="form-controls">

                <div style={{display: "none"}}>
                {this.state.loadingPerc >= 100 && this.state.confValid==true ? 
                // <HashRouter>
                //   <Redirect exact to={DEMO ? "/checkin/confidence/verified/demoBooking" : '/checkin/confidence/verified/booking/'} />
                // </HashRouter>
                setTimeout( ()=>{
                  this.goToNextScreen();
                console.log("setNextScreen called")
                }
                , 1000)
                : null}
                </div>
                
                  {/*<Link  exact to={ '/checkin/confidence/verified/booking/' }>
                    <button className="primary w-100" disabled = {this.state.loadingPerc >= 100 && this.state.confValid==true ? false : true}>
                      Ok Got It
                    </button>
                  </Link>*/}

                  <button className="secondary w-100 margin-top-1" onClick = {() => {this.goBack()}}>{t('check_in.cancel')}</button>
                </div>
              </div>
            </div>
            
          </div>
		  </section>
    </div>
    )
  }
}

const getConfidenceConfig = (state) => {
  try {
    return state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.confidenceScores;
  } catch (error) {
    // alert("Error in fetching confidence score config from hotel.");
    return {guestIDValidation: 10, guestPhotoMatching: 10, guestSelfieLiveliness: 10};
  }
}

const mapStateToProps = state => {
  return{
    idCardImage: state.store2.idCardImage,
    idCardImageBack: state.store2.idCardImageBack,
    idCardResponse: state.store2.idCardResponse,
    selectedIdType: state.store2.selectedIdType,
    selfieVideo: state.store2.selfieVideo,
    logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    confidenceScores: getConfidenceConfig(state),
    menuColor: state.store.home.MenuColor,
    guestDetail: state.store.home.guestDetails,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    selfieResponse: state.store2.selfieResponse,
    currentHomePage: state.store2.currentHomePage,
    cardChecksData: state.store2.cardChecksData,
    freshChatData: state.store.freshChatData,
  }
}

export default connect(mapStateToProps,{
  setIdCardImage,
  setIdCardImageBack,
  setSelfieVideo,
  setCardChecksData,
  setSelectedIdType,
  setIdCardResponse,
  setIdCardBackResponse,
  setSelfieResponse, 
  setGoHome,
  sendConfidenceScore,
  popupOpenClose,
  sendAnalytics,
  setCheckinCurrentPageName
})(withTranslation('translations')(ConfidenceShow));